import { render, staticRenderFns } from "./OrganismCreateEditBackup.vue?vue&type=template&id=5845f91b&scoped=true&"
import script from "./OrganismCreateEditBackup.vue?vue&type=script&lang=js&"
export * from "./OrganismCreateEditBackup.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCreateEditBackup.vue?vue&type=style&index=0&id=5845f91b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845f91b",
  null
  
)

export default component.exports